import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 全局配置：活动 id，保存活动相关数据
    global: {
      // activityId: 'f17e2e76-b88b-42e9-a311-48897ae5ba8a',
      activityId: '936ed0d1-3ae1-4ee4-9ad6-fad2154109f2',
      guests: [],
      activity: {
        themes: [{
          speeches: [{ guests: [] }]
        }],
        partner_categories: [
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] },
          { 'partners': [{ 'logo': { 'url': '' } }] }
        ]
      },
      vice_activities: [
        { speeches: [{ speeches: [] }] }
      ]
    },
    // 微信分享配置
    weChat: {
      imgUrl: 'https://summit-img.geekpark.net/ifx-icon.png',
      desc: 'GeekPark IF X\n2019.12.20-12.22\n751D·PARK 北京时尚设计广场',
      title: '极客公园创新大会十周年'
    },
    // 模块：视频
    video: {
      shallow: { // 浅色时的顶部和底部图片
        topPicture: 'https://summit-img.geekpark.net/gpk-meeting-module/1-1-%E8%A7%86%E9%A2%91-rebuild-%E9%BB%91-1385%C3%97120.svg',
        bottomPicture: 'https://summit-img.geekpark.net/gpk-meeting-module/1-1-%E8%A7%86%E9%A2%91-rebuild-%E9%BB%91-1385%C3%9780.svg'
      },
      deep: { // 深色时的顶部和底部图片
        topPicture: 'https://summit-img.geekpark.net/gpk-meeting-module/1-1-%E8%A7%86%E9%A2%91-rebuild-%E7%99%BD-1385%C3%97120.svg',
        bottomPicture: 'https://summit-img.geekpark.net/gpk-meeting-module/1-1-%E8%A7%86%E9%A2%91-rebuild-%E7%99%BD-1385%C3%9780.svg'
      },
      poster: 'https://summit-img.geekpark.net/cover.png', // 视频封面
      source: 'https://summit-img.geekpark.net/video/%E5%A4%A7%E4%BC%9A%E8%8A%B1%E7%B5%AE.MP4' // 视频源地址
    },
    // 模块：亮点-文字加图片列表
    lightSpotImages: {
      paragraph: [
        '如果机器注定要与我们协作相生成为参与改造世界的重要力量我们该如何让数据、算法、计算力、感知力，成为最有价值的竞争力？不要在空谈概念中错过一个新的时代',
        '和最优秀的科学家、企业家、创新者与资本力量一起看清机遇，改变惯性启动对这个世界的「迭代再造」'
      ],
      images: [
        'https://summit-img.geekpark.net/gpk-meeting-module/2-2-%E4%BA%AE%E7%82%B9%E5%98%89%E5%AE%BE-600x1080-1.jpg',
        'https://summit-img.geekpark.net/gpk-meeting-module/2-2-%E4%BA%AE%E7%82%B9%E5%98%89%E5%AE%BE-600x1080-2.jpg',
        'https://summit-img.geekpark.net/gpk-meeting-module/2-2-%E4%BA%AE%E7%82%B9%E5%98%89%E5%AE%BE-600x1080-3.jpg',
      ],
    },
    // 模块：亮点-图文混合列表
    LightSpotMix: [
      {
        headPhoto: 'https://summit-img.geekpark.net/gpk-meeting-module/2-1-%E8%AE%BA%E5%9D%9B%E4%BA%AE%E7%82%B9-750x670-1.jpg', // 头图
        kind: '论坛类型', // 论坛类型
        title: ['论坛主题论坛主题', '论坛主题'], // 论坛主题,
        paragraph: '论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍' // 论坛详情介绍
      }, {
        headPhoto: 'https://summit-img.geekpark.net/gpk-meeting-module/2-1-%E8%AE%BA%E5%9D%9B%E4%BA%AE%E7%82%B9-750x670-2.jpg', // 头图
        kind: '论坛类型', // 论坛类型
        title: ['论坛主题论坛主题', '论坛主题'], // 论坛主题,
        paragraph: '论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍' // 论坛详情介绍
      }, {
        headPhoto: 'https://summit-img.geekpark.net/gpk-meeting-module/2-1-%E8%AE%BA%E5%9D%9B%E4%BA%AE%E7%82%B9-750x670-3.jpg', // 头图
        kind: '论坛类型', // 论坛类型
        title: ['论坛主题论坛主题', '论坛主题'], // 论坛主题,
        paragraph: '论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍论坛详情介绍' // 论坛详情介绍
      },
    ],
    // 模块：往届嘉宾
    guestsPrevious: {
      nav: {
        normal: {
          topImage: 'https://summit-img.geekpark.net/IFX-10th%20logo.svg',
          middleImage: 'https://summit-img.geekpark.net/gpk-meeting-module/%E5%BE%80%E5%B1%8A%E5%98%89%E5%AE%BEnav.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87.svg'
        },
        hover: {
          topImage: 'https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg',
          middleImage: 'https://summit-img.geekpark.net/gpk-meeting-module/%E5%BE%80%E5%B1%8A%E5%98%89%E5%AE%BEnav-white.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87-%E7%99%BD.svg'
        }
      }
    },
    // 模块：特别展
    specialExhibition: {
      images: [
        'https://summit-img.geekpark.net/gpk-meeting-module/7-1-%E5%B1%95%E5%8C%BA-%E5%A4%B4%E5%9B%BE-550x930.svg',
        'https://summit-img.geekpark.net/gpk-meeting-module/7-1-%E5%B1%95%E5%8C%BA-%E5%9B%BE1-550x930.jpg',
        'https://summit-img.geekpark.net/gpk-meeting-module/7-1-%E5%B1%95%E5%8C%BA-%E5%9B%BE2-550x304.jpg',
        'https://summit-img.geekpark.net/gpk-meeting-module/7-1-%E5%B1%95%E5%8C%BA-%E5%9B%BE3-550x304.jpg',
        'https://summit-img.geekpark.net/gpk-meeting-module/7-1-%E5%B1%95%E5%8C%BA-%E5%9B%BE4-550x304.jpg'

      ],
      title: '极客博物馆',
      paragraph: [
        '我们希望找到那些曾经带给我们惊喜和感动的科技产品，带你重拾它们迷人的特质。',
        '《极客博物馆》已经成为极客之选最受欢迎的栏目之一，它和无数科技爱好者产生了情感共鸣。我们将在 IF X 期间推出特别展览情怀之外，你将有机会重新把玩、审视这些经典产品，它们和现代的科技产品又能碰撞出什么火花？敬请关注。'
      ],
      nav: {
        normal: {
          topImage: 'https://summit-img.geekpark.net/IFX-10th%20logo.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/V2-%E7%89%B9%E5%88%AB%E5%B1%95.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/V2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-%E8%8B%B1%E6%96%87.svg'
        },
        hover: {
          topImage: 'https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/V2-%E7%89%B9%E5%88%AB%E5%B1%95-%E7%99%BD.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/V2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-%E8%8B%B1%E6%96%87-%E7%99%BD.svg'
        }
      }
    },
    // 模块：本届嘉宾
    guestsCurrent: {
      nav: {
        normal: {
          topImage: 'https://summit-img.geekpark.net/IFX-10th%20logo.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E6%9C%AC%E5%B1%8A%E5%98%89%E5%AE%BE.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/%E6%9C%AC%E5%B1%8A%E5%98%89%E5%AE%BE-%E8%8B%B1%E6%96%87-%E9%BB%91%E8%89%B2.svg'
        },
        hover: {
          topImage: 'https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/%E6%9C%AC%E5%B1%8A%E5%98%89%E5%AE%BE-%E7%99%BD%E8%89%B2.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/%E6%9C%AC%E5%B1%8A%E5%98%89%E5%AE%BE-%E8%8B%B1%E6%96%87-%E7%99%BD%E8%89%B2.svg'
        }
      }
    },
    // 模块：按天区分的论坛介绍
    forumIntroduceByDay: {
      daysInfo: [{
        brief: '论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介',
        detail: '论坛介绍详情，<br>论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情',
        image: 'https://summit-img.geekpark.net/gpk-meeting-module/4-1-1-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1.svg'
      }, {
        brief: '论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介',
        detail: '论坛介绍详情，<br>论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情',
        image: 'https://summit-img.geekpark.net/gpk-meeting-module/4-1-1-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day2.svg'
      }, {
        brief: '论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介论坛介绍简介',
        detail: '论坛介绍详情，<br>论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情论坛介绍详情',
        image: 'https://summit-img.geekpark.net/gpk-meeting-module/4-1-1-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day3.svg'
      }],
      nav: {
        normal: {
          topImage: 'https://summit-img.geekpark.net/IFX-10th%20logo.svg',
          middleImage: 'https://summit-img.geekpark.net/gpk-meeting-module/%E8%AE%BA%E5%9D%9B%20%E4%BB%8B%E7%BB%8D.png',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/%E6%9C%AC%E5%B1%8A%E5%98%89%E5%AE%BE-%E8%8B%B1%E6%96%87-%E9%BB%91%E8%89%B2.svg'
        },
        hover: {
          topImage: 'https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg',
          middleImage: 'https://summit-img.geekpark.net/gpk-meeting-module/%E8%AE%BA%E5%9D%9B%20%E4%BB%8B%E7%BB%8D.png',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/%E6%9C%AC%E5%B1%8A%E5%98%89%E5%AE%BE-%E8%8B%B1%E6%96%87-%E7%99%BD%E8%89%B2.svg'
        }
      }
    },
    // 模块：按上下午区分的论坛介绍
    forumIntroduceByPeriod: {
      periodsInfo: [
        [
          'https://summit-img.geekpark.net/gpk-meeting-module/4-1-2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1.svg',
          'https://summit-img.geekpark.net/gpk-meeting-module/4-1-2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1-AM.svg',
          'https://summit-img.geekpark.net/gpk-meeting-module/4-1-2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1-PM.svg'
        ],
        [
          'https://summit-img.geekpark.net/gpk-meeting-module/4-1-2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1.svg',
          'https://summit-img.geekpark.net/gpk-meeting-module/4-1-2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1-AM.svg',
          'https://summit-img.geekpark.net/gpk-meeting-module/4-1-2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1-PM.svg'
        ],
        [
          'https://summit-img.geekpark.net/gpk-meeting-module/4-1-2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1.svg',
          'https://summit-img.geekpark.net/gpk-meeting-module/4-1-2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1-AM.svg',
          'https://summit-img.geekpark.net/gpk-meeting-module/4-1-2-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1-PM.svg'
        ],
      ],
      nav: {
        normal: {
          topImage: 'https://summit-img.geekpark.net/IFX-10th%20logo.svg',
          middleImage: 'https://summit-img.geekpark.net/gpk-meeting-module/%E8%AE%BA%E5%9D%9B%20%E4%BB%8B%E7%BB%8D.png',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/%E6%9C%AC%E5%B1%8A%E5%98%89%E5%AE%BE-%E8%8B%B1%E6%96%87-%E9%BB%91%E8%89%B2.svg'
        },
        hover: {
          topImage: 'https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg',
          middleImage: 'https://summit-img.geekpark.net/gpk-meeting-module/%E8%AE%BA%E5%9D%9B%20%E4%BB%8B%E7%BB%8D.png',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/%E6%9C%AC%E5%B1%8A%E5%98%89%E5%AE%BE-%E8%8B%B1%E6%96%87-%E7%99%BD%E8%89%B2.svg'
        }
      }
    },
    // 模块：论坛无头像版本
    forumMainTable: {
      daysInfo: [{
        brief: '第一天简介第一天简介第一天简介第一天简介第一天简介第一天简介第一天简介第一天简介第一天简介第一天简介',
        image: 'https://summit-img.geekpark.net/gpk-meeting-module/4-2-1-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1.svg'
      }, {
        brief: '第二天简介第二天简介第二天简介第二天简介第二天简介第二天简介第二天简介第二天简介第二天简介第二天简介',
        image: 'https://summit-img.geekpark.net/gpk-meeting-module/4-2-1-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day2.svg'
      }, {
        brief: '第三天简介第三天简介第三天简介第三天简介第三天简介第三天简介第三天简介第三天简介第三天简介第三天简介',
        image: 'https://summit-img.geekpark.net/gpk-meeting-module/4-2-1-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day3.svg'
      }],
      nav: {
        normal: {
          topImage: 'https://summit-img.geekpark.net/IFX-10th%20logo.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87.svg'
        },
        hover: {
          topImage: 'https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B-%E7%99%BD.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87-%E7%99%BD.svg'
        }
      }
    },
    // 模块：论坛头像列表版本
    forumMainList: {
      daysInfo: [{
        brief: '第一天简介第一天简介第一天简介第一天简介第一天简介第一天简介第一天简介第一天简介第一天简介第一天简介',
        image: 'https://summit-img.geekpark.net/gpk-meeting-module/4-2-1-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day1.svg'
      }, {
        brief: '第二天简介第二天简介第二天简介第二天简介第二天简介第二天简介第二天简介第二天简介第二天简介第二天简介',
        image: 'https://summit-img.geekpark.net/gpk-meeting-module/4-2-1-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day2.svg'
      }, {
        brief: '第三天简介第三天简介第三天简介第三天简介第三天简介第三天简介第三天简介第三天简介第三天简介第三天简介',
        image: 'https://summit-img.geekpark.net/gpk-meeting-module/4-2-1-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-day3.svg'
      }],
      nav: {
        normal: {
          topImage: 'https://summit-img.geekpark.net/IFX-10th%20logo.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87.svg'
        },
        hover: {
          topImage: 'https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B-%E7%99%BD.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E4%B8%BB%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87-%E7%99%BD.svg'
        }
      }
    },
    // 模块：平行论坛
    parallelForum: {
      link: 'https://techday.geekpark.net/', // 论坛地址链接
      image: 'https://summit-img.geekpark.net/gpk-meeting-module/6-1-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B-TECHDAY.jpg', // 论坛入口图片
      nav: {
        normal: {
          topImage: 'https://summit-img.geekpark.net/IFX-10th%20logo.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87.svg'
        },
        hover: {
          topImage: 'https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B-%E7%99%BD.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/v2-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87-%E7%99%BD.svg'
        }
      }
    },
    // 模块：奖项
    awards: {
      paragraphs: [
        '奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍',
        '奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍奖项介绍'
      ],
      awards: [ // 论坛入口图片
        {
          link: '',
          image: 'https://summit-img.geekpark.net/gpk-meeting-module/8-1-%E5%A5%96%E9%A1%B9-innoawards.jpg',
        },
        {
          link: 'http://ifxawards.geekpark.net/geekchoice',
          image: 'https://summit-img.geekpark.net/gpk-meeting-module/8-1-%E5%A5%96%E9%A1%B9-top20.jpg',
        },
        {
          link: 'http://ifxawards.geekpark.net/geekchoice',
          image: 'https://summit-img.geekpark.net/gpk-meeting-module/8-1-%E5%A5%96%E9%A1%B9-top50.jpg',
        },
        {
          link: 'http://ifxawards.geekpark.net/geekchoice',
          image: 'https://summit-img.geekpark.net/gpk-meeting-module/8-1-%E5%A5%96%E9%A1%B9-%E6%9E%81%E5%AE%A2%E4%B9%8B%E9%80%89.jpg',
        },
        {
          link: 'http://ifxawards.geekpark.net/geekchoice',
          image: 'https://summit-img.geekpark.net/gpk-meeting-module/8-1-%E5%A5%96%E9%A1%B9-%E6%9E%81%E5%AE%A2%E5%BD%B1%E5%93%8D%E5%8A%9B100.jpg',
        },
        {
          link: 'http://ifxawards.geekpark.net/geekchoice',
          image: 'https://summit-img.geekpark.net/gpk-meeting-module/8-1-%E5%A5%96%E9%A1%B9-%E6%9E%81%E5%AE%A2%E9%9B%87%E4%B8%BB.jpg',
        },
        {
          link: 'http://ifxawards.geekpark.net/geekchoice',
          image: 'https://summit-img.geekpark.net/gpk-meeting-module/8-1-%E5%A5%96%E9%A1%B9-%E9%85%B7%E5%85%AC%E5%8F%B8.jpg',
        },
      ],
      nav: {
        normal: {
          topImage: 'https://summit-img.geekpark.net/IFX-10th%20logo.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/%E5%B9%B4%E5%BA%A6%E5%A5%96%E9%A1%B9-%E9%BB%91%E8%89%B2-%E4%B8%AD%E6%96%87.svg',
          bottomImage: 'https://summit-img.geekpark.net/06-%E5%B9%B4%E5%BA%A6%E7%9B%98%E7%82%B9-%E8%8B%B1%E6%96%87.svg'
        },
        hover: {
          topImage: 'https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/%E5%B9%B4%E5%BA%A6%E5%A5%96%E9%A1%B9-%E7%99%BD%E8%89%B2-%E4%B8%AD%E6%96%87.svg',
          bottomImage: 'https://summit-img.geekpark.net/06-%E5%B9%B4%E5%BA%A6%E7%9B%98%E7%82%B9-%E8%8B%B1%E6%96%87%E5%8F%8D%E7%99%BD.svg'
        }
      }
    },
    // 模块：奖项Demo，可删
    awardsDemo: {
      paragraphs: [
        '仅单个奖项仅单个奖项仅单个奖项仅单个奖项仅单个奖项仅单个奖项仅单个奖项仅单个奖项仅单个奖项仅单个奖项仅单个奖项仅单个奖项仅单个奖项',
        '仅单个奖项仅单个奖项仅单个奖项仅单个奖项仅单个奖项仅单个奖项'
      ],
      awards: [ // 论坛入口图片
        {
          link: 'http://ifxawards.geekpark.net/geekchoice',
          image: 'https://summit-img.geekpark.net/gpk-meeting-module/8-2-%E5%8D%95%E5%A5%96%E9%A1%B9-.jpg',
        }
      ],
      nav: {
        normal: {
          topImage: 'https://summit-img.geekpark.net/IFX-10th%20logo.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/%E5%B9%B4%E5%BA%A6%E5%A5%96%E9%A1%B9-%E9%BB%91%E8%89%B2-%E4%B8%AD%E6%96%87.svg',
          bottomImage: 'https://summit-img.geekpark.net/06-%E5%B9%B4%E5%BA%A6%E7%9B%98%E7%82%B9-%E8%8B%B1%E6%96%87.svg'
        },
        hover: {
          topImage: 'https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/%E5%B9%B4%E5%BA%A6%E5%A5%96%E9%A1%B9-%E7%99%BD%E8%89%B2-%E4%B8%AD%E6%96%87.svg',
          bottomImage: 'https://summit-img.geekpark.net/06-%E5%B9%B4%E5%BA%A6%E7%9B%98%E7%82%B9-%E8%8B%B1%E6%96%87%E5%8F%8D%E7%99%BD.svg'
        }
      }
    },
    // 模块：订阅
    subscribe: {
      backgroundColor: '#ff3c00', // 背景颜色，默认为 #ff3c00
      image: 'https://summit-img.geekpark.net/gpk-meeting-module/%E8%AE%A2%E9%98%85.png', // 顶部图片, 使用七牛链接
      description: '订阅简介订阅简介订阅简介订阅简介订阅简介', // 订阅简介
      color: '#fff', // 订阅简介文字颜色，默认为 #fff
      contentType: 'IFX', // 订阅接口所需参数，大会描述
      activityId: 'f17e2e76-b88b-42e9-a311-48897ae5ba8a' // 订阅接口所需参数，活动id
    },
    // 模块：购票入口
    ticketEntrance: {
      link: 'https://events.geekpark.net/orders/index/cn/if20', // 购票地址链接
      image: 'https://summit-img.geekpark.net/gpk-meeting-module/9-1-%E8%B4%AD%E7%A5%A8%E5%85%A5%E5%8F%A3.jpg', // 购票入口图片
    },
    // 模块：合作伙伴
    partners: {
      nav: {
        normal: {
          topImage: 'https://summit-img.geekpark.net/IFX-10th%20logo.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/04-%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4-%E8%8B%B1%E6%96%87.svg'
        },
        hover: {
          topImage: 'https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg',
          middleImage: 'https://summit-img.geekpark.net/ifx/pc/%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4-%E7%99%BD.svg',
          bottomImage: 'https://summit-img.geekpark.net/ifx/pc/04-%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4-%E8%8B%B1%E6%96%87-%E7%99%BD.svg'
        }
      }
    },
    // 模块：联系我们
    contactUs: {
      enquire: { // 观众资讯邮箱和图片
        email: 'IFX@geekpark.net',
        image: 'https://summit-img.geekpark.net/ifx@geekpark.net.svg'
      },
      bd: { // 商务合作邮箱和图片
        email: 'IF.BD@geekpark.net',
        image: 'https://summit-img.geekpark.net/if.bd@geekpark.net.svg'
      },
      media: { // 媒体联系邮箱和图片
        email: 'IF.Media@geekpark.net',
        image: 'https://summit-img.geekpark.net/if.media@geekpark.ne.svg'
      },
      benefits: '抽奖福利介绍,抽奖福利介绍,抽奖福利介绍,抽奖福利介绍' // 抽奖福利介绍
    },
    // 模块：往届回顾
    previousReview: {
      image: 'https://summit-img.geekpark.net/gpk-meeting-module/WechatIMG5.png', // 大会 logo 图片
      previousList: [
        {
          link: 'https://if.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/ifx-w-logo.svg',
          hoverImage: 'https://summit-img.geekpark.net/ifx-h-logo.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
        {
          link: 'http://if2019.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/2019-year.svg',
          hoverImage: 'https://summit-img.geekpark.net/2019-year-hover.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
        {
          link: 'http://if2018.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/2018-year.svg',
          hoverImage: 'https://summit-img.geekpark.net/2018-year-hover.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
        {
          link: 'http://if2017.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/2017-year.svg',
          hoverImage: 'https://summit-img.geekpark.net/2017-year-hover.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
        {
          link: 'http://if2016.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/2016-year.svg',
          hoverImage: 'https://summit-img.geekpark.net/2016-year-hover.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
        {
          link: 'http://if2015.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/2015-year.svg',
          hoverImage: 'https://summit-img.geekpark.net/2015-year-hover.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
      ],
      previousListBackup: [ // 控制 hover 图片变更回滚用，与 previousList 保持一致
        {
          link: 'https://if.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/ifx-w-logo.svg',
          hoverImage: 'https://summit-img.geekpark.net/ifx-h-logo.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
        {
          link: 'http://if2019.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/2019-year.svg',
          hoverImage: 'https://summit-img.geekpark.net/2019-year-hover.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
        {
          link: 'http://if2018.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/2018-year.svg',
          hoverImage: 'https://summit-img.geekpark.net/2018-year-hover.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
        {
          link: 'http://if2017.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/2017-year.svg',
          hoverImage: 'https://summit-img.geekpark.net/2017-year-hover.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
        {
          link: 'http://if2016.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/2016-year.svg',
          hoverImage: 'https://summit-img.geekpark.net/2016-year-hover.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
        {
          link: 'http://if2015.geekpark.net/',
          defaultImage: 'https://summit-img.geekpark.net/2015-year.svg',
          hoverImage: 'https://summit-img.geekpark.net/2015-year-hover.svg',
          arrow:'https://summit-img.geekpark.net/arrow.svg',
          arrowHover:'https://summit-img.geekpark.net/arrow-hover.svg',
        },
      ],
    }
  },
  mutations: {
    UPDATE_MEETING_DATA(state, { activity, guests, vice_activities }) {
      state.global.activity = activity;
      state.global.guests = guests;
      state.global.vice_activities = vice_activities;
    },
    UPDATE_PREVIOUS_LIST(state, list) {
      state.previousReview.previousList = list;
    },
  },
  actions: {
    getMeetingData({ commit, state }) {
      const activityId = state.global.activityId;
      axios.get(`https://events.geekpark.net/api/v1/activities/${activityId}`)
        .then(res => {
          const { activity, guests, vice_activities } = res.data;
          commit('UPDATE_MEETING_DATA', {
            activity,
            guests,
            vice_activities
          });
        });
    }
  },
  modules: {},
});
